import AWS from "aws-sdk";
import {
  aws_access_key_id,
  aws_secret_access_key,
  bucketName,
  hostname,
  projectName,
} from "./config";
import axios from "axios";
import { UPLOAD_FILE_AWS } from "../store/dialogue/dialogue.type";
import { setToast } from "./toast";

export const uploadFile = async (
  File,
  folderStructure,
  dispatch,
  loaderType,
) => {
  try {
    const ext = File?.name?.split(".").pop();
    const now = Date.now();

    const folder = projectName + "/" + folderStructure;
    const file = `w-${now}.${ext}`;

    const formData = new FormData();
    formData.append("folderStructure", folder);
    formData.append("keyName", file);
    formData.append("content", File);
    const response = await axios.post(
      `admin/file/upload-file?folderStructure=${folder}&keyName=${file}`,
      formData,
      {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          console.log("UPLOAD PROGRESS ", percentCompleted);

          dispatch &&
            dispatch({
              type: UPLOAD_FILE_AWS,
              payload: {
                uploadFilePercent:
                  percentCompleted < 100 ? percentCompleted : 0,
                loaderType: percentCompleted < 100 ? loaderType : "",
              },
            });
        },
      },
    );

    if (!response.data.status) {
      setToast("error", response.data.message || "File upload failed");
    }

    const resDataUrl = response.data.url;
    const spaceEndpoint = new AWS.Endpoint(`${hostname}`);

    const fileName = projectName + "/" + folderStructure + "/" + file;
    const s3 = new AWS.S3({
      endpoint: spaceEndpoint,
      accessKeyId: aws_access_key_id,
      secretAccessKey: aws_secret_access_key,
    });

    const params = {
      Bucket: bucketName,
      Key: fileName,
      Expires: 60,
    };

    const imageURL = await new Promise((resolve, reject) => {
      s3.getSignedUrl("getObject", params, (err, url) => {
        if (err) {
          console.error("Error generating presigned URL:", err);
          reject(err);
          return;
        }
        resolve(url);
      });
    });

    return { resDataUrl, imageURL };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const covertURl = async (FileName) => {
  try {
    const spaceEndpoint = new AWS.Endpoint(`${hostname}`);

    const s3 = new AWS.S3({
      endpoint: spaceEndpoint,
      accessKeyId: aws_access_key_id,
      secretAccessKey: aws_secret_access_key,
    });

    const params = {
      Bucket: bucketName,
      Key: projectName + "/" + FileName,
      Expires: 100,
    };

    const imageURL = await new Promise((resolve, reject) => {
      s3.getSignedUrl("getObject", params, (err, url) => {
        if (err) {
          console.error("Error generating presigned URL:", err);
          reject(err);
          return;
        }
        resolve(url);
      });
    });

    return { FileName, imageURL };
  } catch (error) {
    console.error(error);
    throw error;
  }
};
